import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Complete() {

	const [order, setOrder] = useState(null);
	const nav = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get("session_id");
	//console.log('running useEffect');


    if (sessionId) {
      fetch(`https://seniorspray.ca/retrieveCheckout.php?session_id=${sessionId}`)
        .then((res) => res.json())
        .then((data) => setOrder(data));

    }

  }, []);



	if (!order) return (
		<><br /><p>Loading order details?</p>
		</>
	);

	//console.debug(order);

	nav('/complete', {state: order}, 3000);


}
